<template>
	<div class="sign-in-container form-container">
		<div class="center-flex-inline">
			<p>New here?&nbsp;&nbsp;&nbsp;<span class="link" @click="handleClickSignUp">Sign up</span> now!</p>
		</div>
		<div class="contact-form">
			<div class="contact-field" :class="updatePhoneClass()">
				<BaseIcon
					class="input-field-icon icon-mobile"
					icon="mobile"
					:isCustom="true"
					size="1x"/>
				<input
					:class="(liveValidate) ? 'is-success' : 'is-danger'"
					class="input text-input has-icon"
					type="tel"
					placeholder="Mobile Number"
					v-model="phone"/>
			</div>
			<div class="contact-field">
				<BaseTermsBlurb>By tapping Sign In, you agree to our</BaseTermsBlurb>
			</div>
			<div class="contact-field">
				<BaseButton
					:classNames="['button--modifier', 'input-field-button']"
					title="Sign In"
					type="scaleable-fixed-square"
					:disabled="!validPhone"
					@click="handleClickSignIn"/>
			</div>
			<a class="small-link" @click.prevent="_navigateToGuestForm">or continue as guest</a>
		</div>
	</div>
</template>

<script>
	// TODO should not have to extend this vue
	import PhonelessUserCollapsible from '@Account/PhonelessUserCollapsible.vue';
	import ContactDetailsVue from '@Account/ContactDetails/ContactDetails.vue';
	import contactDetailsMixin from '@Mixin/contactDetailsMixin';
	import loginMixin from '@Mixin/loginMixin';
	import headerMixin from '@Mixin/headerMixin';
	export default {
		mixins: [
			contactDetailsMixin,
			loginMixin,
			headerMixin,
		],
		components: {
			'phoneless-user-collapsible': PhonelessUserCollapsible,
		},
		props: {},
		data() {
			return {
				requestingLogin: false,
			};
		},
		methods: {
			handleClickSignIn() {
				this.requestingLogin = true;
				this.signIn();
			},
			handleClickSignUp() {
				this._navigateToSignUp();
			},
			signIn() {
				this.sendLoginRequest().then((response) => {
					this.initialLoginSuccess(response);
				});
			},
		},
		mounted() {
			this._setHeaderTitle('Sign In');
		}
	}
</script>

<style lang="scss" scoped>
	@import 'commonStyle/checkout';
	@import 'commonStyle/contactForm';
	.small-link {
		width: 100%;
		text-align: right;
		text-decoration: underline;
	}
	@include mobile {}
	@include desktop {}
	@include tablet {}
</style>


// WEBPACK FOOTER //
// src/components/account/SignIn.vue